import { UniqueId } from "../_uniqueId";
import DevicePropertyForm from "./devicePropertyForm";

export default class DeviceForm extends UniqueId  {
    name:string = '';
    typeId: number = 0;
    centerId: number = 0;
    properties: DevicePropertyForm[] = [];
}